



export class FinancialUtils {


  static calculateDiscountPcnt(aStartPrice: number, aCurrentPrice: number): number {

    if((aStartPrice <= 0) || (aCurrentPrice <= 0) || (aCurrentPrice >= aStartPrice)){ return 0 }

    return (( aCurrentPrice - aStartPrice) / aStartPrice)

  }

  static calculateEDLPLift(anElasticity: number, aTrueBasePrice: number, anObervedBasePrice: number): number {
    // calculate Discount Percent
    let discountPcnt = FinancialUtils.calculateDiscountPcnt( aTrueBasePrice, anObervedBasePrice )

    let lift = Math.pow(1 + discountPcnt, anElasticity) - 1

    return lift
  }

  static calculateIncremental(aTotalQty: number, aLiftPcnt: number): number {
    return (aTotalQty * aLiftPcnt/ ( 1 + aLiftPcnt) )
  }

  static calculateMarginPcnt(SellingPrice: number, CostPrice: number): number {
    let sp = SellingPrice || 0
    let cp = CostPrice || 0
    if(cp <= 0){ return 0}

    return ((sp/cp) - 1)
  }

  static calculateSellingPrice(CostPrice: number, MarginPcnt: number): number {
    let mrg = MarginPcnt || 0
    let cp = CostPrice || 0
    if(cp <= 0){ return 0}

    return ((1 + mrg) * cp)
  }



}